import * as React from 'react';
import classnames from 'classnames';
import { isNil } from 'lodash';

import ContextMenuItemGeneric from './types/ContextMenuItemGeneric';
import ContextMenuItemLists from './types/ContextMenuItemLists';
import ContextMenuItemModal from './types/ContextMenuItemModal';
import ContextMenuItemShippingAddress from './types/ContextMenuItemShippingAddress';
import ContextMenuItemBulkMessage from './types/ContextMenuItemBulkMessage';
import ContextMenuItemCancelOffer from './types/ContextMenuItemCancelOffer';
import ContextMenuItemCreateEditList from './types/ContextMenuItemCreateEditList';

import type { ContextMenuItem as ContextMenuItemType, Data } from 'types';

type Props = {
  item: ContextMenuItemType,
  data?: Data,
  onClose: (b: ContextMenuItemType, a: React.MouseEvent) => void
};

class ContextMenuItem extends React.PureComponent<Props> {
  handleClick = (event: React.MouseEvent) => {
    const { item, data, onClose } = this.props;
    const updatedData = !isNil(data) ? { ...data, name: item.name } : null;

    if (item.onClick) {
      event.stopPropagation();
      // $FlowIgnore
      item.onClick(!isNil(updatedData) ? updatedData : item.name);
      onClose(item, event);
    }
  };

  handleLink = (event: React.MouseEvent) => {
    const { item, onClose } = this.props;

    event.stopPropagation();
    onClose(item, event);
  };

  handleClose = (event: React.MouseEvent) => {
    const { item, onClose } = this.props;

    onClose(item, event);
  };

  renderContainer(): React.ReactNode {
    const { item } = this.props;

    switch (item.type) {
      case 'lists':
        return (<ContextMenuItemLists item={item} onModalClosed={this.handleClose} />);
      case 'modal':
        return (<ContextMenuItemModal item={item} onModalClosed={this.handleClose} />);
      case 'shipping_address':
        return (<ContextMenuItemShippingAddress item={item} onModalClosed={this.handleClose} />);
      case 'cancel_offer':
        return (<ContextMenuItemCancelOffer item={item} onModalClosed={this.handleClose} />);
      case 'bulk_message':
        return (<ContextMenuItemBulkMessage item={item} onModalClosed={this.handleClose} />);
      case 'edit_list':
        return (<ContextMenuItemCreateEditList item={item} onModalClosed={this.handleClose} />);
      default:
        return <ContextMenuItemGeneric item={item} />;
    }
  }

  render(): React.ReactNode {
    const { item } = this.props;

    if (item.type === 'separator') {
      return <div className="context-menu-separator" />;
    }

    if (item.type === 'heading') {
      return (
        <div className="context-menu-heading">
          {item.text}
        </div>
      );
    }

    if (item.link) {
      return item.openInNewTab ? (
        <a
          href={item.link}
          target="_blank"
          rel="noopener noreferrer"
          className="context-menu-item context-menu-item--link"
          onClick={this.handleLink}
        >
          {this.renderContainer()}
        </a>
      ) : (
        <a
          href={item.link}
          className="context-menu-item context-menu-item--link"
          onClick={this.handleLink}
        >
          {this.renderContainer()}
        </a>
      );
    }

    const contextMenuItemClass = classnames({
      'context-menu-item': true,
      [`context-menu-item--${item.type ? item.type : 'generic'}`]: true,
      'context-menu-item--is-disabled': item.disabled
    });

    return (
      <div className={contextMenuItemClass} onClick={this.handleClick}>
        {this.renderContainer()}
      </div>
    );
  }
}

export default ContextMenuItem;
